import { useAppDispatch } from 'app/store/configureStore';
import { useCallback } from 'react';
import { markNotificationAsReadEffect } from 'app/store/Notifications/effects';

export const useNotificationAsRead = () => {
  const dispatch = useAppDispatch();
  const markNotificationAsRead = useCallback(
    (guid: string) => dispatch(markNotificationAsReadEffect({ guid })),
    [dispatch]
  );
  return { markNotificationAsRead };
};
